export const FREE_TRIAL_USED_KEY = "propaganda_free_trial_used";
